import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import { IStatement } from '../../../model/statement'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import fetchReferences from './fetch-references'
import { IReference } from '../../../model/reference'

export default async function removeStatementReference(context: BareActionContext<StatementState, RootState>, payload: { statement: IStatement, reference: IReference })
{
    statementUtils.statementService.removeReference(payload.statement, payload.reference).then((result: any) => {
        fetchReferences(context, payload.statement)
    })

    return
}
